import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { ColumnsEdit } from "../../../../../../types/models/column-table-edit";
import dayjs from "dayjs";
import { validatePhoneNumber } from "pages/AdministrativePersonnel/HumanResourcesManagement/CandidateDirectory/Tab/FormAdd/config";
const {
  INPUT,
  DATE,
  DATE_DISABLE_NO_DAY,
  COMBO_BOX,
  AUTO_COMPLETE,
  CURRENCY,
  NUMBER,
  DATE_DISABLE,
  DATE_PRE,
  DATE_DAY_INPUT,
} = FIELD_TYPE;
const validatePositiveInteger = (_, value) => {
  if (!value || /^[1-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}

//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };

const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã biểu thuế",
    name: "maBieuThue",
    disable: true,
    rules: [{ required: true, message: "Chưa nhập mã đợt tuyển dụng" }],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 14, xl: 14 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 10, xl: 10},
  },
  {
    type: DATE_DISABLE_NO_DAY,
    label: "Thời gian áp dụng từ",
    name: "thoiGianApDungTu",
    expand: true,
    optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
    disableDate: false,
    rules: [
      {
        required: true,
        message: "Bắt buộc phải chọn thời gian áp dụng từ",
      },
    ],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 12, xl: 12},
    labelCol: { xs: 24,sm:10, md: 10, lg: 12, xl: 12},
  },
  {
    type:  DATE_DISABLE_NO_DAY,
    label: "Thời gian áp dụng đến",
    name: "thoiGianApDungDen",
    expand: true,
    optionsTime: { showTime: false, format: FORMAT_TIME.dayFull },
    disableDate: false,
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 12, xl: 12},
    labelCol: { xs: 24,sm:10, md: 10, lg: 12, xl: 12},
  },
];
const columns: ColumnsEdit = [
  {

    key: 1,
    show: true,
    rules: [{validator: validatePositiveInteger}],
    width: 200,
    title: "Bậc thuế",
    dataIndex: "bacThue",
    type: "INPUT",
    align: "right"
  },
  {
    type: "CURRENCY",
    dataIndex: "thuNhapTinhThueTu",
    key: 2,
    title: "Thu nhập tính thuế từ",
    show: true,
    width: 200,
    align: "center",
  },
  {
    type: "CURRENCY",
    dataIndex: "thuNhapTinhThueDen",
    key: 3,
    title: "Thu nhập tính thuế đến",
    show: true,
    width: 200,
    align: "center",
  },
  {
    dataIndex: "thueXuat",
    key: 4,
    title: "Thuế xuất (%)",
    show: true,
    width: 200,
    rules: [{validator: validatePositiveInteger}],
    suffix: "%",
    type: "INPUT",
  },
  {
    title: "",
    dataIndex: "",
    key: "action",
    align: "center",
    width: 60,
    fixed: "right" as any,
    show: true,
  },
];
export { columns, dataFields };
